import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { GetTransactionListReqData } from "./GetTransactionListReqData";
import { GetTransactionListResData } from "./GetTransactionListResData";

const ENDPOINT = "/cash_flow/transactions_paginated";

export class GetTransactionListCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: GetTransactionListReqData = null;

    constructor(payload: GetTransactionListReqData) {
        super();
        this.payload = payload;
    }

    public async execute(): Promise<GetTransactionListResData> {
        let res = await this.executeCommand(this.payload);
        return new GetTransactionListResData(res);
    }
}
